import {IAccConfigInvoice} from "../../../model/respone/category/IAccConfigInvoice";
import {generateActionTypeIds} from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eAccConfigInvoiceActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IAccConfigInvoice[],
    LOAD_ERRR: "",

    SAVE_START: {} as IAccConfigInvoice,
    SAVE_SUCCESS: {} as IAccConfigInvoice,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IAccConfigInvoice,
    CLOSE_EDIT_MODAL: undefined,

    SELECTED_ID: [] as number[],
    DELETE_MANY_START: [] as number[],
    DELETE_MANY_SUCCESS: undefined,
    DELETE_MANY_ERROR: "",
};
export const eAccConfigInvoiceActionIds = generateActionTypeIds(
    eAccConfigInvoiceActionsObj,
    "CONFIG_INVOICE"
);
export type IAccConfigInvoiceActionTypes = IGenericActionType<
    typeof eAccConfigInvoiceActionsObj,
    "CONFIG_INVOICE"
>;
